import React, { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Badge, Box, ButtonBase, Tooltip } from '@mui/material';

// assets
import CloudSyncIcon from '@mui/icons-material/CloudSync';

import { useConfigMonitor } from 'Contextos/ConfigMonitorContext';
import ConfigStatusDialog from './ConfigStatusDialog';

// ==============================|| CONFIG STATUS SECTION (HEADER BUTTON) ||============================== //

const ConfigStatusSection = () => {
    const theme = useTheme();
    const [openDialog, setOpenDialog] = useState(false);

    const { globalBadge, globalTooltip, isSyncingAll } = useConfigMonitor();

    // Determinar color de badge según estado general
    const getBadgeColor = () => {
        switch (globalBadge) {
            case 'error':
                return '#f44336'; // Rojo (falló crítica)
            case 'info':
                return '#2196f3'; // Azul (cargándose)
            case 'warning':
                return '#ff9800'; // Naranja (pendiente)
            case 'success':
                return '#4caf50'; // Verde (todas críticas listas)
            default:
                return '#9e9e9e'; // Gris (idle)
        }
    };

    const handleOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const badgeColor = getBadgeColor();
    const isLoading = globalBadge === 'info' || isSyncingAll;

    return (
        <>
            <Box sx={{ ml: { xs: 1, sm: 1.5 }, mr: { xs: 0.5, sm: 1 } }}>
                <Tooltip title={globalTooltip} arrow>
                    <ButtonBase
                        sx={{
                            borderRadius: '12px',
                            overflow: 'hidden'
                        }}
                        onClick={handleOpen}
                    >
                        <Avatar
                            variant="rounded"
                            sx={{
                                ...theme.typography.commonAvatar,
                                ...theme.typography.mediumAvatar,
                                transition: 'all .25s ease-in-out',
                                background:
                                    theme.palette.mode === 'dark'
                                        ? theme.palette.dark.main
                                        : globalBadge === 'error'
                                        ? 'rgba(244, 67, 54, 0.12)'
                                        : theme.palette.primary.light,
                                color:
                                    globalBadge === 'error'
                                        ? theme.palette.error.main
                                        : theme.palette.primary.dark,
                                '&:hover': {
                                    background:
                                        globalBadge === 'error'
                                            ? theme.palette.error.main
                                            : theme.palette.primary.dark,
                                    color: '#ffffff',
                                    transform: 'scale(1.05)'
                                }
                            }}
                        >
                            <Badge
                                variant="dot"
                                sx={{
                                    '& .MuiBadge-badge': {
                                        backgroundColor: badgeColor,
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
                                        animation: isLoading ? 'pulseBadge 1.5s infinite ease-in-out' : 'none',
                                        '@keyframes pulseBadge': {
                                            '0%': { transform: 'scale(0.9)', opacity: 0.7 },
                                            '50%': { transform: 'scale(1.2)', opacity: 1 },
                                            '100%': { transform: 'scale(0.9)', opacity: 0.7 }
                                        }
                                    }
                                }}
                            >
                                <CloudSyncIcon
                                    sx={{
                                        fontSize: '1.35rem',
                                        animation: isLoading ? 'spinSync 2.5s infinite linear' : 'none',
                                        '@keyframes spinSync': {
                                            '0%': { transform: 'rotate(0deg)' },
                                            '100%': { transform: 'rotate(360deg)' }
                                        }
                                    }}
                                />
                            </Badge>
                        </Avatar>
                    </ButtonBase>
                </Tooltip>
            </Box>

            {/* Modal de Detalle */}
            <ConfigStatusDialog open={openDialog} onClose={handleClose} />
        </>
    );
};

export default ConfigStatusSection;
